<clr-modal [clrModalOpen]="service.isUploading && !service.hideProgress" [clrModalClosable]="false">

    <h3 class="modal-title">{{ 'Header.FileUpload' | translate }}</h3>
    <div class="modal-body">
        <div class="card-list">
            <div class="card-list-item" *ngFor="let file of service.fileQueue; let i = index">

                <app-image-container *ngIf="file.preview && file.preview !== ''"
                    [src]="file.preview">
                </app-image-container>

                <span style="flex: 0 0 20%;">
                    {{getFileSize(file.selectedFile.size)}} Mb
                </span>

                <div style="flex: 1;" *ngIf="file.sub"
                    style="padding-right: 12px;">
                    <clr-progress-bar clrLabeled=true [clrValue]=" file.percent">
                    </clr-progress-bar>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="onCancel()">{{ 'Forms.Cancel' | translate }}</button>
    </div>

</clr-modal>
